import {Injectable} from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class PerformaInfoService {
    // pure-SPA model: window.pfData is no longer injected by a server-rendered host, so guard
    // against it being undefined. these legacy fields fall back to empty/null until/unless a
    // backend endpoint supplies them (tracked as FU-2).
    private static readonly pfData = (window as any).pfData ?? {};

    public supportInfo = PerformaInfoService.pfData.supportInfo || {};
    public validationErrorField = PerformaInfoService.pfData.validationErrorField || null;
    public errorPath = PerformaInfoService.pfData.errorPath || null;
}
